import { AuthState } from '@okta/okta-auth-js';

import { LocationGroupsMassCreates } from '../../services/backend/LocationGroupsMassCreates';
import { useBaseApiClient } from '../useBaseApiClient';

export const useLocationGroupsMassCreates: () => LocationGroupsMassCreates<AuthState> = () => {
  return useBaseApiClient(LocationGroupsMassCreates);
};
